import { useHeader } from "@/hooks/headerContext";
import { usePathname } from "next/navigation";
import { ROUTES } from "@/@core/constants/routes";
import { useVenueListPage } from "@/hooks/listPageContext";
import { useTranslation } from "@/hooks/translationContext";

export const useHeaderTitle = () => {
    const { venue, district, service } = useHeader();
    const { t } = useTranslation();
    const pathname = usePathname();
    const { isVenueListPage } = useVenueListPage();

    const i18nTags = () => {
        return {
            venue,
            service: service?.title,
            district: district?.title,
        };
    };

    const replaceKey = (key: string) => {
        return t(key, i18nTags());
    };

    const I18N_TITLE_KEYS = {
        venue: "venue",
        [ROUTES.CAMPAIGNS]: "campaign",
        [ROUTES.EVENTS]: "event",
        [ROUTES.ALL_COMPANIES]: "company",
    };

    const getKey = () => {
        if (isVenueListPage) return I18N_TITLE_KEYS.venue;
        return I18N_TITLE_KEYS[pathname];
    };

    const getTitle = () => {
        if (!district?.id && service?.id) {
            return replaceKey(`search-title-service-${getKey()}`);
        }

        if (district?.id && !service?.id) {
            return replaceKey(`search-title-district-${getKey()}`);
        }

        if (district?.id && service?.id) {
            return replaceKey(`search-title-district-and-service-${getKey()}`);
        }

        return "";
    };

    return {
        title: getTitle(),
        isVenueListPage,
    };
};